import type { UDFCategory } from "../ReportServices";
import type { EntityTypeItem, FilterRow, ColumnRow } from "../TemplateServices";
import type { TemplateDataReferenceMode } from "../TemplateWorkbookService";

export const MAX_ENTITY_OPTIONS_IN_DROPDOWN = 150;

export type RoleItem = {
  id: string;
  name: string;
};

export type FilterRowDefinition = {
  key: string;
  displayName: string;
  dropdownEndpoint?: string;
};

export type ColumnRowDefinition = {
  key: string;
  displayName: string;
};

export type TemplateTabViewProps = {
  isLoadingConfiguration: boolean;
  workbookDetected: boolean;
  operationError: string;
  operationNotice: string;
  isWorkbookBannerDismissed: boolean;
  setIsWorkbookBannerDismissed: (value: boolean) => void;
  selectedEntityType: string;
  entityTypeQuery: string;
  setEntityTypeQuery: (value: string) => void;
  entityNames: EntityTypeItem[];
  loadingEntityNames: boolean;
  loadingFilters: boolean;
  loadingColumns: boolean;
  loadingRoles: boolean;
  selectedFilters: FilterRow[];
  availableFilters: FilterRowDefinition[];
  showFilterPicker: boolean;
  setShowFilterPicker: (value: boolean) => void;
  selectedColumns: ColumnRow[];
  availableColumns: ColumnRowDefinition[];
  showColumnPicker: boolean;
  setShowColumnPicker: (value: boolean) => void;
  udfCategories: UDFCategory[];
  selectedUdfs: string;
  includeUdfs: boolean;
  setIncludeUdfs: (value: boolean) => void;
  templateName: string;
  setTemplateName: (value: string) => void;
  activeEmptyVisibleSheetName: string;
  dataReferenceMode: TemplateDataReferenceMode;
  setDataReferenceMode: (value: TemplateDataReferenceMode) => void;
  roles: RoleItem[];
  selectedRoles: string[];
  setSelectedRoles: (value: string[]) => void;
  isGenerating: boolean;
  isSaving: boolean;
  hasGeneratedWorkbook: boolean;
  handleClearAll: () => void;
  handleEntityTypeChange: (value: string) => void;
  handleAddFilter: (filterKey: string) => void;
  handleResetFilters: () => void;
  handleRemoveFilter: (key: string) => void;
  handleFilterDrop: (fromIndex: number, toIndex: number) => void;
  handleFilterTypeChange: (key: string, type: string) => void;
  handleFilterDisplayNameChange: (key: string, displayName: string) => void;
  handleFilterRequiredChange: (key: string, required: boolean) => void;
  handleFilterCascadeChange: (key: string, cascadeFrom: string | null) => void;
  handleAddColumn: (colKey: string) => void;
  handleResetColumns: () => void;
  handleRemoveColumn: (key: string) => void;
  handleColumnDisplayNameChange: (key: string, newDisplayName: string) => void;
  handleColumnExcelFormatChange: (key: string, excelFormat: string) => void;
  handleColumnDrop: (fromIndex: number, toIndex: number) => void;
  handleUdfCategoryToggle: (categoryName: string, isSelected: boolean) => void;
  handleUdfItemToggle: (itemId: string, isSelected: boolean) => void;
  handleMasterUdfToggle: (isSelected: boolean) => void;
  handleGenerateWorkbook: () => Promise<void>;
  handleSaveTemplate: () => Promise<void>;
  setHasGeneratedWorkbook: (value: boolean) => void;
};
